module.exports = __webpack_public_path__ + "img/img.f3b4b2ff.png";